import { cn } from "@/utils/cn";
import type { ReportTypeDef } from "./types";

interface ReportTypePickerProps {
  reportTypes: ReportTypeDef[];
  value: string;
  onChange: (id: string) => void;
}

export default function ReportTypePicker({ reportTypes, value, onChange }: ReportTypePickerProps) {
  return (
    <section className="flex flex-col gap-4 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h3 className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
            1. Choisissez un rapport
          </h3>
          <p className="mt-0.5 text-xs text-foreground-500">
            {reportTypes.length} rapport{reportTypes.length > 1 ? "s" : ""} disponible
            {reportTypes.length > 1 ? "s" : ""} pour votre espace.
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3">
        {reportTypes.map((type) => {
          const selected = type.id === value;
          return (
            <button
              key={type.id}
              type="button"
              onClick={() => onChange(type.id)}
              aria-pressed={selected}
              className={cn(
                "flex items-start gap-3 rounded-lg border p-3.5 text-left transition-colors cursor-pointer",
                selected
                  ? "border-primary-400 bg-primary-50"
                  : "border-background-200 bg-background-50 hover:border-primary-300 hover:bg-background-100"
              )}
            >
              <span
                className={cn(
                  "flex h-9 w-9 shrink-0 items-center justify-center rounded-lg",
                  selected ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                )}
              >
                <i className={cn(type.icon, "text-lg")} aria-hidden="true" />
              </span>
              <span className="min-w-0">
                <span className="block truncate text-sm font-label font-medium text-foreground-950">
                  {type.label}
                </span>
                <span className="mt-0.5 block text-xs leading-relaxed text-foreground-500">
                  {type.description}
                </span>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}